import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import * as common from '../../../../../../common'

export const DOC = gql`
  ${common.gql.faFunctions.fragments.categorizationIds.DOC}
  fragment FragmentRateMappingEntry on RateMappingEntry {
    categorization {
      ...FragmentFaFunctionCategorizationIds
    }
    exclusionLabel
    percent
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentRateMappingEntryFragment,
  ents.extra.rate.gl.Mapping.Entry
>({
  exclusionLabel: transformers.PASS_THROUGH,
  faFunctionCategorization: {
    usingFullInput: graphql.transformers.OUT.select(
      'categorization',
      common.gql.faFunctions.fragments.categorizationIds.TRANSFORMER,
    ),
  },
  percent: graphql.transformers.OUT.default(transformers.PASS_THROUGH, 0),
})
